<template>
  <div class="p-event__members-select-list">
    <v-autocomplete
      v-if="!disabled"
      ref="members"
      :value="value"
      v-bind="$attrs"
      :menu-props="{ closeOnContentClick: true }"
      :items="contactsList"
      :class="inputClass"
      item-value="contactId"
      item-text="displayNameWithCompany"
      append-icon=""
      multiple
      hide-selected
      return-object
      @input="onInput"
      @change="$refs.members.lazySearch=''"
    >
      <template v-slot:selection="{ index }">
        <label
          v-if="index === 0 && ($refs.members && !$refs.members.lazySearch)"
          class="v-label p-placeholder"
        >
          {{ $t('event.edit.addMember') }}
        </label>
      </template>
      <template v-slot:item="{ item }">
        <span :class="{ 'font-weight-bold': item.isMember }">{{ item.displayNameWithCompany }}</span>
      </template>
      <template v-slot:append-item>
        <v-divider></v-divider>
        <div class="p-list-add-item-link" @click="editContactDialog = true">
          {{ $t('contact.addNewContact') }}
        </div>
      </template>
    </v-autocomplete>
    <v-list dense>
      <v-list-item v-if="!disabled">
        <v-list-item-content>
          <div class="d-flex justify-end">
            <v-btn
              rounded
              small
              style="text-transform: none;"
              :disabled="allMembersAreAdded"
              @click.stop="onAddAllMembersClick"
            >
              <span v-if="!allMembersAreAdded">{{ $t('contact.addAllMembers') }}</span>
              <span v-else>{{ $t('contact.allMembersAreAdded') }}</span>
            </v-btn>
          </div>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-for="member in valueMapped"
        :key="member.contactId"
      >
        <p-avatar
          :char="member.displayName[0]"
          :email="member.email"
          :color="member.color"
          list-item-avatar
        ></p-avatar>
        <v-list-item-content>
          <div class="d-flex justify-space-between align-center">
            <div>{{ member.displayNameWithCompany }}</div>
            <v-text-field
              v-model="member.hours"
              :placeholder="$t('event.edit.hours')"
              type="number"
              class="p-text-field"
              hide-details
              dense
              @input="handleHoursInput"
            ></v-text-field>
          </div>
        </v-list-item-content>
        <v-list-item-icon v-if="!disabled">
          <v-btn icon @click="removeMember(member.contactId)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item-icon>
      </v-list-item>
    </v-list>

    <contact-edit-dialog
      :dialog.sync="editContactDialog"
      :contact="null"
      @add="onContactAdded"
    ></contact-edit-dialog>
  </div>
</template>


<script>
import { mapGetters } from 'vuex'

import PAvatar from '@/components/PAvatar'

import ContactEditDialog from '@/views/Contacts/ContactEditDialog'


export default {
  inheritAttrs: false,


  components: {
    PAvatar,
    ContactEditDialog
  },


  props: {
    value: Array,
    inputClass: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },


  data () {
    return {
      editContactDialog: false
    }
  },


  computed: {
    ...mapGetters('contact', ['shortContactById', 'shortContactsForProject']),
    ...mapGetters('project', ['currentProjectId']),

    contactsList () {
      return this.shortContactsForProject(this.currentProjectId)
    },

    valueMapped () {
      return this.value?.length ? this.value.map(member => {
        const contact = this.shortContactById(member.contactId)
        return {
          ...member,
          ...contact
        }
      }) : []
    },

    membersIds () {
      return this.contactsList.filter(contact => contact.isMember).map(contact => contact.contactId)
    },

    valueIds () {
      return this.value.map(el => el.contactId)
    },

    allMembersAreAdded () {
      if (!this.contactsList.length || !this.value.length) {
        return false
      }
      let allMembersAreAdded = true
      this.membersIds.forEach(memberId => {
        if (!this.valueIds.includes(memberId)) {
          allMembersAreAdded = false
        }
      })

      return allMembersAreAdded
    }
  },


  methods: {
    onAddAllMembersClick () {
      const membersToAdd = []
      this.contactsList.forEach(contact => {
        if (contact.isMember && !this.valueIds.includes(contact.id)) {
          membersToAdd.push(contact)
        }
      })
      if (membersToAdd.length) {
        this.value.push(...membersToAdd)
      }
      this.$emit('input', this.value)
    },

    onInput (value) {
      this.$emit('input', value)
    },

    onContactAdded (contact) {
      this.value.push({ contactId: contact.id, hours: 0 })
      this.$emit('input', this.value)
    },

    removeMember (id) {
      const i = this.value.findIndex(x => x.contactId === id)
      this.value.splice(i, 1)
      this.$emit('input', this.value)
    },

    handleHoursInput () {
      const value = []
      this.valueMapped.forEach(el => {
        const elem = { ...el }
        if (el.hours === '') {
          elem.hours = null
        }
        value.push(elem)
      })
      this.$emit('input', value)
    }
  }
}
</script>
